<template>
  <VBlock v-if="active" class="wrapper" ref="wrapper">
    <VSpan text="+1" :size="13" :color="TextColor.gray3" />
  </VBlock>
</template>

<script>
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VSpan, { TextColor } from '@/presentationals/v2/components/layouts/atoms/VSpan'

export default {
  name: 'QuantityAnimation',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VBlock,
    VSpan
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  opacity: 0.5;
  top: 0;
  left: 0;

  animation: fade-out 1s ease-out both alternate;
}

@keyframes fade-out {
  0% {
    opacity: 0.5;
    top: 0;
  }

  100% {
    opacity: 0;
    top: -16px;
  }
}
</style>